<template>
  <div class="card-container">
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">Configuração de Endossos</h3>
        <vs-button
          v-if="$can($actionsDefault.Escrita, subjectPermission)"
          color="primary"
          class="alter-button"
          @click="openModal"
          icon="edit"
          icon-pack="material-icons"
        >
        </vs-button>
      </div>

      <div class="values-container">
        <div class="value-item" v-for="field in fields" :key="field.id">
          <span class="label">{{ field.label }}</span>
          <span class="value">{{
            formatValue(field.value, field.inputType)
          }}</span>
        </div>
      </div>
    </div>

    <Modal
      :active.sync="isModalOpen"
      title="Cadastro de Configuração de Endosso"
      class="endorsement-modal"
      @close="closeModal"
    >
      <vs-form @submit.prevent="handleSubmit">
        <div class="modal-content">
          <div class="form-group" v-for="field in fields" :key="field.id">
            <label>{{ field.label }}</label>
            <vs-input
              v-if="field.inputType === 'text'"
              v-model="formData[field.name]"
              type="text"
            />
            <vs-input
              v-else-if="field.inputType === 'number'"
              v-model="formData[field.name]"
              type="number"
              step="0.01"
              min="0"
            />
            <money
              v-else-if="field.inputType === 'money'"
              class="w-full vs-inputx vs-input--input normal"
              :name="field.name"
              :id="field.name"
              v-model="formData[field.name]"
              v-validate="{ required: true }"
              v-bind="money"
              :state="validateState(field.name)"
              :danger="validateClass(field.name)"
              @input.native="handleMoneyInput($event, field)"
            ></money>
          </div>
        </div>
        <div class="form-actions">
          <vs-button @click="closeModal" color="dark" outline block>
            Cancelar
          </vs-button>
          <vs-button @click="handleSubmit" color="success" block>
            Salvar
          </vs-button>
        </div>
      </vs-form>
    </Modal>
  </div>
</template>

<script>
import Modal from '../../../../../components/Modal.vue';
import endorsement from '../../../../../services/endorsement';
import { Money } from 'v-money';
import notify from '../../../../../utils/notify';

export default {
  name: 'EndorsementCard',
  props: ['subjectPermission'],
  components: { Modal, Money },
  data() {
    return {
      isModalOpen: false,
      fields: [],
      formData: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
      },
    };
  },
  computed: {
    errors() {
      return this.$validator.errors.all();
    },
  },
  created() {
    this.fetchFields();
  },
  methods: {
    async fetchFields() {
      try {
        this.fields = await endorsement.getConfigs();

        this.fields.forEach((field) => {
          this.$set(this.formData, field.name, field.value || '0');
        });
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao carregar as configurações.');
      }
    },
    openModal() {
      this.resetFormFields();
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    resetFormFields() {
      this.fields.forEach((field) => {
        this.formData[field.name] = field.value || '0';
      });
    },
    async handleSubmit() {
      try {
        const payload = {
          configs: this.fields.map((field) => ({
            id: field.id,
            value: String(this.formData[field.name]),
          })),
        };

        await endorsement.updateConfigs(payload);

        notify.notifySuccess(
          this.$vs,
          'Configuração de endosso salva com sucesso!',
          'Sucesso',
        );

        this.closeModal();
        await this.fetchFields();
      } catch (error) {
        notify.notifyFail(
          this.$vs,
          'Falha ao salvar a configuração de endosso.',
        );
      }
    },
    formatValue(value, inputType) {
      if (inputType === 'money') {
        return parseFloat(value).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
        });
      }
      return value;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },
    handleMoneyInput(event, field) {
      let value = event.target.value;

      value = value.replace(/[^0-9,]/g, '').replace(',', '.');

      if (field && field.name) {
        this.formData[field.name] = value;
      }
    },
  },
};
</script>

<style scoped>
/* CARD */
.card-container {
  width: 100%;
}

.card {
  width: 100%;
  padding: 20px;
  background: #fff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 12px;
  margin-bottom: 16px;
}

.card-title {
  font-size: 1.4rem;
  font-weight: bold;
  color: #333;
}

.alter-button {
  height: 40px;
  font-weight: bold;
}

/* VALORES */
.values-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 24px;
}

.value-item {
  display: flex;
  flex-direction: column;
  text-align: left;
  min-width: 30%;
}

.label {
  font-size: 14px;
  font-weight: bold;
  color: #777;
}

.value {
  font-size: 18px;
  font-weight: 600;
  color: #222;
}

/* MODAL */
.modal-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-actions {
  display: flex;
  justify-content: end;
  gap: 12px;
  margin-top: 24px;
}

.vs-button {
  font-weight: bold;
}
</style>
